import Vue from 'vue'
import Router from 'vue-router'
import { defaultSeo, setSeo, setStructuredData } from '../utils/seo'
Vue.use(Router)

//老链接兼容：hash 路由时代的分享链接（微信文章/二维码里的 www.jinlanmeng.cn/#/cultivate）
//在 history 模式下 hash 会被忽略导致落到首页，这里重定向到对应的 history 路径
if (window.location.hash.indexOf('#/') === 0) {
  window.location.replace(window.location.hash.slice(1))
}


//解决编程式路由往同一地址跳转时会报错的情况
const originalPush = Router.prototype.push;
const originalReplace = Router.prototype.replace;
//push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};
//replace
Router.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
};


//默认 TDK 与 meta 操作见 src/utils/seo.js

const router = new Router({
  //history 模式：URL 无 #，每个路由都是独立地址，可被搜索引擎与 AI 爬虫收录
  mode: 'history',
  scrollBehavior(to, from, saveTop) {
    if (saveTop) {
      return saveTop;
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'layout',
      component: () => import('../views/main'),
      redirect: '/index',
      children: [
        {
          path: '/index',
          name: 'index',
          meta: {
            layout: 'index',
            title: defaultSeo.title,
            description: defaultSeo.description,
            keywords: defaultSeo.keywords
          },
          component: () => import('../views/index')
        },
        {
          path: '/sreach',
          name: 'sreach',
          meta: {
            layout: 'index',
            title: '站内搜索-金蓝盟',
            description: '金蓝盟官网站内搜索，快速查找管理咨询、企业培训、专家团队、客户案例、新闻动态等内容。',
            keywords: '金蓝盟,站内搜索,管理咨询,企业培训'
          },
          component: () => import('../views/sreach')
        },
        {
          path: '/menu',
          name: 'menu',
          meta: {
            layout: 'index',
            title: '网站导航-金蓝盟',
            description: '金蓝盟官网导航，管理咨询、企业培训、专家团队、客户案例、人才招聘等栏目入口。',
            keywords: '金蓝盟,网站导航,管理咨询,企业培训'
          },
          component: () => import('../views/menu')
        },
        {
          path: '/cultivate',
          name: 'cultivate',
          meta: {
            layout: 'index',
            title: '企业培训-管理培训课程|企业内训-金蓝盟',
            description: '金蓝盟企业培训服务，涵盖管理培训课程、企业内训、实战工作坊等，帮助企业系统提升中高层管理能力。',
            keywords: '企业培训,管理培训课程,企业内训,中层管理培训,金蓝盟',
            faq: [
              {
                question: '金蓝盟提供哪些企业培训服务？',
                answer: '金蓝盟企业培训涵盖管理培训课程、企业内训、实战工作坊等多种形式，面向企业中高层管理者系统提升管理能力。'
              },
              {
                question: '如何查看近期开课并报名？',
                answer: '可在金蓝盟官网培训页面的开课一览表查看历史与近期开课信息，并通过页面上的联系方式咨询报名。'
              },
              {
                question: '培训课程是否支持按企业需求定制？',
                answer: '支持。金蓝盟可根据企业的行业特点、发展阶段与管理痛点，定制专属的企业内训课程内容。'
              }
            ]
          },
          component: () => import('../views/cultivate')
        },
        {
          path: '/itService',
          name: 'itService',
          meta: {
            layout: 'index',
            title: 'IT咨询-企业数字化管理咨询-金蓝盟',
            description: '金蓝盟IT咨询服务，提供企业数字化、信息化管理咨询与落地方案，助力企业实现管理升级。',
            keywords: 'IT咨询,数字化咨询,企业信息化,管理咨询,金蓝盟'
          },
          component: () => import('../views/itService')
        },
        {
          path: '/capital',
          name: 'capital',
          meta: {
            layout: 'index',
            title: '金合资本-股权投资|资本运作-金蓝盟',
            description: '金合资本是金蓝盟旗下资本服务平台，提供股权投资、资本运作、投后管理等企业金融服务。',
            keywords: '金合资本,股权投资,资本运作,金蓝盟'
          },
          component: () => import('../views/capital')
        },
        {
          path: '/listed',
          name: 'listed',
          meta: {
            layout: 'index',
            title: '上市助推-IPO辅导|企业上市咨询-金蓝盟',
            description: '金蓝盟上市助推服务，为企业提供IPO辅导、上市规划、规范治理等一站式上市咨询服务。',
            keywords: '上市助推,IPO辅导,企业上市咨询,上市规划,金蓝盟'
          },
          component: () => import('../views/listed')
        },
        {
          path: '/team',
          name: 'team',
          component: () => import('../views/main'),
          redirect: '/team/index',
          children: [
            {
              path: 'index',
              name: 'team',
              meta: {
                layout: 'index',
                title: '专家团队-管理咨询专家|培训讲师-金蓝盟',
                description: '金蓝盟专家团队，汇聚管理咨询专家与实战培训讲师，为企业提供专业的管理咨询与内训服务。',
                keywords: '专家团队,管理咨询专家,培训讲师,金蓝盟专家'
              },
              component: () => import('../views/team')
            },
            {
              path: 'detail',
              name: 'team',
              meta: {
                layout: 'index',
                title: '专家详情-金蓝盟专家团队',
                description: '金蓝盟专家详情页，了解专家的擅长领域、咨询方向与服务内容。',
                keywords: '金蓝盟专家,专家详情,管理咨询专家'
              },
              component: () => import('../views/teamdetail')
            }
          ]
        },
        {
          path: '/server',
          name: 'server',
          component: () => import('../views/main'),
          redirect: '/server/index',
          children: [
            {
              path: 'index',
              name: 'server',
              meta: {
                layout: 'index',
                title: '管理咨询服务-管理咨询公司-金蓝盟',
                description: '金蓝盟管理咨询服务，涵盖战略管理、组织流程、人力资源等企业管理咨询模块，助力企业业绩增长。',
                keywords: '管理咨询服务,企业管理咨询,战略咨询,流程优化,人力资源咨询',
                faq: [
                  {
                    question: '金蓝盟提供哪些管理咨询服务？',
                    answer: '金蓝盟管理咨询服务涵盖战略管理、组织流程、人力资源等企业管理咨询模块，可根据企业实际情况组合定制。'
                  },
                  {
                    question: '如何与金蓝盟开始咨询合作？',
                    answer: '可通过官网咨询页面的在线入口或客服联系方式提交需求，金蓝盟将安排相应领域的专家与您对接沟通。'
                  },
                  {
                    question: '咨询方案是否可以按企业情况定制？',
                    answer: '可以。金蓝盟会结合企业所在行业、发展阶段与经营痛点，输出定制化的管理咨询方案并辅导落地。'
                  }
                ]
              },
              component: () => import('../views/server')
            },
            {
              path: 'detail',
              name: 'server',
              meta: {
                layout: 'index',
                title: '咨询服务详情-金蓝盟',
                description: '金蓝盟管理咨询服务详情，了解具体咨询服务的内容、流程与方案。',
                keywords: '咨询服务详情,管理咨询,金蓝盟'
              },
              component: () => import('../views/servedetail')
            }
          ]
        }

      ]
    },
    {
      path: '/index',
      name: 'index',
      meta: {
        title: defaultSeo.title,
        description: defaultSeo.description,
        keywords: defaultSeo.keywords
      },
      component: () => import('../views/index')
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      meta: {
        title: '关于金蓝盟-管理咨询公司简介',
        description: '金蓝盟是专业的企业管理咨询公司，了解金蓝盟的企业文化、发展历程与团队实力。',
        keywords: '关于金蓝盟,公司简介,管理咨询公司,企业文化'
      },
      component: () => import('../views/aboutUS/index'),
    },
    {
      path: '/newsDetail',
      name: 'newsDetail',
      meta: {
        title: '新闻动态-金蓝盟',
        description: '金蓝盟新闻动态与行业资讯，了解公司最新活动与管理咨询行业观点。',
        keywords: '金蓝盟新闻,新闻动态,行业资讯'
      },
      component: () => import('../views/newsDetail/index.vue'),
    },
    {
      //新闻详情的路径参数形式：/news/<对外编号>，可预渲染、可被搜索引擎收录；老链接 /news/123、/newsDetail?Id=123 仍可用
      path: '/news/:publicId([0-9A-Za-z]+)',
      name: 'newsDetail',
      meta: {
        title: '新闻详情-金蓝盟',
        description: '金蓝盟新闻动态与行业资讯，了解公司最新活动与管理咨询行业观点。',
        keywords: '金蓝盟新闻,新闻动态,行业资讯'
      },
      component: () => import('../views/newsDetail/index.vue'),
    },
    {
      path: '/recruit',
      name: 'recruit',
      meta: {
        title: '人才招聘-金蓝盟管理咨询公司招聘',
        description: '金蓝盟人才招聘，诚邀管理咨询、企业培训领域的优秀人才加盟，与金蓝盟共同成长。',
        keywords: '金蓝盟招聘,管理咨询公司招聘,人才招聘'
      },
      component: () => import('../views/recruit/index.vue'),
    },
    {
      path: '/recruitDetail',
      name: 'recruitDetail',
      meta: {
        title: '岗位详情-金蓝盟招聘',
        description: '金蓝盟招聘岗位详情，了解岗位职责与任职要求。',
        keywords: '金蓝盟招聘,岗位详情'
      },
      component: () => import('../views/recruitDetail/index.vue'),
    },
    {
      path: '/business',
      name: 'business',
      meta: {
        title: '商务合作-金蓝盟',
        description: '金蓝盟商务合作通道，欢迎就管理咨询、企业培训、渠道推广等事宜洽谈合作。',
        keywords: '商务合作,渠道合作,金蓝盟合作'
      },
      component: () => import('../views/business/index.vue'),
    },
    {
      path: '/case',
      name: 'case',
      meta: {
        title: '客户案例-企业管理咨询案例|企业培训案例-金蓝盟',
        description: '金蓝盟客户案例，展示企业管理咨询、企业培训项目在不同行业的实践成果。',
        keywords: '客户案例,企业管理咨询案例,企业培训案例,金蓝盟案例'
      },
      component: () => import('../views/case/index.vue'),
    },
    {
      path: '/caseDetail',
      name: 'caseDetail',
      meta: {
        title: '客户案例详情-金蓝盟',
        description: '金蓝盟客户案例详情，了解项目背景、咨询方案与落地成效。',
        keywords: '案例详情,管理咨询案例,金蓝盟'
      },
      component: () => import('../views/caseDetail/index.vue'),
    },
    {
      //案例/培训课程详情的路径参数形式：/case/<对外编号>，可预渲染、可被搜索引擎收录；老链接 /case/456、/caseDetail?Id=456 仍可用
      path: '/case/:publicId([0-9A-Za-z]+)',
      name: 'caseDetail',
      meta: {
        title: '客户案例详情-金蓝盟',
        description: '金蓝盟客户案例与培训课程详情，了解项目背景、咨询方案与落地成效。',
        keywords: '案例详情,管理咨询案例,企业培训课程,金蓝盟'
      },
      component: () => import('../views/caseDetail/index.vue'),
    },
     {
      //咨询详情的路径形式：/server/大类/小类（中文分类名，可预渲染、可被收录）；老链接 /server/detail?name=&names= 仍可用
      path: '/server/:first/:second',
      name: 'serverDetail',
      meta: {
        title: '咨询服务详情-金蓝盟',
        description: '金蓝盟管理咨询服务详情，按咨询类别查看对应的咨询案例与解决方案。',
        keywords: '咨询服务详情,企业管理咨询,金蓝盟'
      },
      component: () => import('../views/servedetail')
    },
    {
      //专家详情的路径形式：/team/专家姓名（可预渲染、可被收录）；老链接 /team/detail?name= 仍可用
      path: '/team/:name',
      name: 'teamDetail',
      meta: {
        title: '专家详情-金蓝盟专家团队',
        description: '金蓝盟专家详情页，了解专家的擅长领域、主讲课程与咨询服务。',
        keywords: '金蓝盟专家,专家详情,管理咨询专家,培训讲师'
      },
      component: () => import('../views/teamdetail')
    },
    {
      //岗位详情的路径形式：/recruit/<对外编号>（可预渲染、可被收录）；老链接 /recruit/123、/recruitDetail?Id= 仍可用
      path: '/recruit/:publicId([0-9A-Za-z]+)',
      name: 'recruitDetail',
      meta: {
        title: '岗位详情-金蓝盟招聘',
        description: '金蓝盟招聘岗位详情，了解岗位职责与任职要求。',
        keywords: '金蓝盟招聘,岗位详情'
      },
      component: () => import('../views/recruitDetail/index.vue')
    },
     {
      path: '/test',
      name: 'test',
      meta: { title: '客户案例详情' },
      component: () => import('../views/test/index.vue'),
    }
  ]
})

//切换路由时动态更新页面 TDK（title/description/keywords）与路由级结构化数据
router.afterEach(to => {
  const meta = to.meta || {}
  let title = meta.title || defaultSeo.title
  let description = meta.description || defaultSeo.description
  //详情页带上具体名称，提升搜索结果可读性：/team/王少巍、/server/大类/战略规划
  if (to.params.name) {
    title = to.params.name + '-金蓝盟专家'
    description = to.params.name + '：' + description
  } else if (to.params.second) {
    title = to.params.second + '-金蓝盟咨询服务'
    description = to.params.second + '：' + description
  }
  setSeo({
    title,
    description,
    keywords: meta.keywords || defaultSeo.keywords,
    noindex: false
  })
  if (meta.faq && meta.faq.length) {
    setStructuredData({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: meta.faq.map(item => ({
        '@type': 'Question',
        name: item.question,
        acceptedAnswer: { '@type': 'Answer', text: item.answer }
      }))
    })
  } else {
    setStructuredData(null)
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js